export default "__VITE_PUBLIC_ASSET__fb74d725__"